import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";

const NewsOverviewPage = Scrivito.provideObjClass("NewsOverviewPage", {
  attributes: {
    ...defaultPageAttributes,
    navigationBackgroundImage: ["reference", { only: ["Image"] }],
    body: ["widgetlist", { only: "SectionContentWidget" }],
    title: "string",
    image: ["reference", { only: "Image" }],
    headline: "string",
    subHeadline: "stringlist",
    description: "html",
    isNavigationPage: ["enum", { values: ["yes", "no"] }],
    categoryFilter: "stringlist",
    newsCountPerPage: "integer",
    navigationIcon: "string",
    ...metadataAttributes,
  },
  extractTextAttributes: [
    "body",
    "title",
    "segmentName",
    "headline",
    "description",
  ],
});

export default NewsOverviewPage;
